<template>
	<div class="main-contents display">
		<div class="tit">
			<template>이슈 프로젝트 노출</template><nbsp/>
			<template v-if="seq">수정</template><template v-else>등록</template>
			<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.go(-1)">
		</div>
		<div class="search-box btn">
			<div class="sub_btn dl" @click="delBanner()" v-if="seq">삭제</div>
		</div>
		<!-- 배너등록 -->
		<div class="banner_box">
			<div class="list">
				<div class="label">노출뉴스제목</div>
				<InputComp title="노출뉴스제목" v-model="data.exposureNewsTitle" rules="required"/>
			</div>
			<div class="list">
				<div class="label">노출뉴스내용</div>
				<InputComp title="노출뉴스내용" v-model="data.exposureNewsCont" rules="required"/>
			</div>
			<div class="list">
				<div class="label">뉴스센터일련번호</div>
				<InputComp title="뉴스센터일련번호" v-model="data.newsCenterSeq" rules="required"/>
			</div>
			<div class="list">
				<div class="label">노출여부</div>
				<SelectComp title="노출여부" tagName="div" class="radio" type="radio" v-model="data.exposureYn" list="Y:노출,N:노출종료" rules="required"/>
			</div>
			<div class="list rank">
				<div class="label">노출순위</div>
				<SelectComp title="노출순위" v-model="data.displayOrd" list="1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,10:10" />
			</div>
			<div class="list bn_img">
				<div class="label">이미지</div>
				<file-select title="이미지" tagNm="div" type="admin" v-model="temp.bannerImg" :name="data.attaFileNm" accept=".jpg,.jpeg,.png,.bmp,.gif" rules="required"/>
				<p>{{descMsg['01'].banner}}</p>
			</div>
			
		</div>
		<div class="select_btn">
			<div class="btn_01" @click="$router.go(-1)">취소</div>
			<div class="btn_02" @click="save()">적용</div>
		</div>
	</div>
</template>

<script>
import fileSelect from "@/components/FileSelect.vue";
export default {
	components: { fileSelect },
	data() {
		return {
			seq: this.$route.params.exposureNewsSeq,
			// seq: this.$route.query.banner,
			// div: this.$route.query.div,
			// mdiv: this.$route.query.mdiv,

			descMsg : {
				'01': {
					'banner' : '※ 이미지 사이즈는 1920 X 450 (픽셀)로 업로드 해 주세요.',
					'detail' : '※ 이미지의 가로사이즈는 1920 (픽셀) 이하로 업로드 해 주세요.',
				},
				'02': {
					'banner' : '※ 이미지 사이즈는 1225 X 1100 (픽셀) 이하로 업로드 해 주세요.',
					'detail' : '※ 이미지의 가로사이즈는 1920 (픽셀) 이하로 업로드 해 주세요.',
				},
				'03': {
					'banner' : '※ 이미지의 가로사이즈는 1920 (픽셀) 이하로 업로드 해 주세요.',
					'detail' : '※ 이미지의 가로사이즈는 1920 (픽셀) 이하로 업로드 해 주세요.',
				},
			},

			data:{},
			temp: {},

			now: new Date().format('yyyyMMddHHmm'),
		};
	},
	beforeMount(){
		if(this.seq){
            this.$.httpPost('/api/main/bbs/adm/news/getExposureNewsInfo', {exposureNewsSeq:this.seq})
                .then(res => {
					// console.log(res.data);
                    this.data = res.data.info;
                }).catch(this.$.httpErrorCommon);
		}
	},
	methods : {
		save(){
			var files = [];
			if(this.temp.bannerImg instanceof File){
				files.push(this.temp.bannerImg);
                this.data.bannerImgFileNm = this.temp.bannerImg.name;
				this.data.bannerImgFileYn = 'Y';
			}
			
			this.$.fileUpload('IMG', files, '/api/main/bbs/adm/news/setExposureNews', this.data)
                .then(() => {
					alert('저장이 완료되었습니다.');
                    this.$router.go(-1);
                }).catch(this.$.httpErrorCommon);
		},
		delBanner(){
			// console.log('delBanner start', JSON.stringify(this.checks));
			var list = [ this.data ];
			this.$.popup('/adm/man/MAN901P02', {list})
				.then(res => {
					if(res) {
						// 회원가입 화면으로 이동
						//this.getList();
						this.$router.go(-1);
					}
				});
			
		}
	}
}
</script>